<template>
  <div class="bottom-btn ccui-clearfix" v-if="item.isEmpty !== 1">
    <!--
        1.未登录只显示“查看详情”按钮
        2.未报名显示“我要报名”，“查看详情” 按钮
        3.已报名显示“执行”，“查看详情”按钮
        4.公告已执行完成，只显示“查看详情”按钮
        checkFlag  2->可参与  3->已报名
        （先判断 schemeStatus ！== 3(执行中) 不能报名 ）
        -->
    <!--<el-col :span="12" class="fl"
      ><el-button
        type="primary"
        size="mini"
        class="notice-btn notice-btn-split-line"
        @click="signUp(item)"
        v-if="item.schemeStatus === '3' && item.checkFlag === '2'"
        >我要报名</el-button
      >
    </el-col>-->
    <!--<el-col :span="12" class="fl"
      ><el-button
        type="primary"
        size="mini"
        class="notice-btn notice-btn-split-line"
        @click="perform(item)"
        v-if="item.schemeStatus === '3' && item.checkFlag === '3'"
        >进入项目</el-button
      >
    </el-col>-->
    <el-col :span="24" class="fl"
      ><el-button
        type="primary"
        size="mini"
        class="notice-btn"
        @click="handleView(item)"
        >{{ $t("page.content.viewDetail") }}</el-button
      ></el-col
    >
  </div>
</template>
<script>
import { mixinHomePage } from "@/mixins/mixin-common/mixin-homePage";
export default {
  name: "noticeItemBottomBtn",
  mixins: [mixinHomePage],
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      // isLogin: this.$store.getters.getAccessToken
    };
  },
  computed: {
    /*detailSpan() {
      return item => {
        if (this.isLogin) {
          if (
            (item.checkFlag === "2" || item.checkFlag === "3") &&
            item.schemeStatus === "3"
          ) {
            return 12;
          }
        }
        return 24;
      };
    }*/
  }
};
</script>

<style scoped></style>
